import React from "react";


TierDivisionsInteractiveComponent.divisions = [
	'I',
	'II',
	'III',
];

export default function TierDivisionsInteractiveComponent(props) {
	const { onDivisionClick, selectedDivision } = props;

	return (
		<div className='divisions'>
			<div className='division_links flex flex-space-around'>
				{TierDivisionsInteractiveComponent.divisions.map((division, index) => (
					<div
						key={index}
						className={`division_number no-select ${selectedDivision === index + 1 ? 'selected' : ''}`}
						onClick={onDivisionClick ? onDivisionClick.bind(null, index + 1) : undefined}
					>
						{division}
					</div>
				))}
			</div>
		</div>
	);
}